import { Component, OnInit, OnDestroy, Inject, NgZone, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { cDepartments, departments } from 'src/types/departments';
import { cTillproduct, tillproduct } from 'src/types/tillproduct';
import { tillRoll } from 'src/types/tillRoll';
import { tillproductoptions } from 'src/types/tillproductoptions';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { bmxurl, getAccess } from 'src/globals';
import { tillproducts_returndata } from 'src/types/tillproduct_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { DrawerService } from '../_services/drawer.service';
import { cTillSale } from 'src/types/tillsale';
import { cTillsaleDiscountvalidate, cTillsaleVouchervalidate } from 'src/types/tillsaleDiscountvalidate';
import { cTillSalePayment } from 'src/types/tillsalepayment';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { venueuser } from 'src/types/venueuser';
import { venueuser_returndata } from 'src/types/venueuser_returndata';

@Component({
  selector: 'app-till',
  templateUrl: './till.component.html',
  styleUrls: ['./till.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TillComponent implements OnInit, OnDestroy {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  Departments: cDepartments[];
  Products: cTillproduct[];
  tillRole: tillRoll[];
  deptProducts: cTillproduct[];
  selectedIndex: number = 0;
  TotalCost: number = 0;
  displayModal: boolean = false;
  displayModalOverPaymentWarning: boolean = false;
  displayModalChange: boolean = false;
  Change: number = 0;
  //Snapshot of the items just paid for, used to build the prep list after cash off.
  pendingReceiptItems: tillRoll[] = [];

  //Number the API stamps on a sale when it saves it. Held on screen until dismissed.
  magicNumber: string = '';
  showMagicNumber: boolean = false;

  //Prep list shown after a sale is cashed off. Kitchen items go to the Kitchen Display
  //System, but everything else (coffees, confectionery) leaves the server with nothing to
  //work from - these two lists give them something to tick off.
  displayModalServerItems: boolean = false;
  serverItemsOutstanding: { name: string, options: string, qty: number }[] = [];
  serverItemsCompleted: { name: string, options: string, qty: number }[] = [];

  Amount: number = 0;
  TillRoleTotal: number = 0;
  httpResponse: any;
  CurrencySymbol: string = localStorage.getItem("Currency") || "GBP";

  CompletedLoading: boolean = false;
  AccessAllowed: boolean = false;
  DataLoaded: boolean = false;

  showOptionsDialog: boolean = false;
  pendingProduct: cTillproduct | null = null;
  selectedOptions: tillproductoptions[] = [];
  editingTillRollItem: tillRoll | null = null;
  expandedItem: tillRoll | null = null;

  // Void
  showVoidConfirm: boolean = false;

  // Till number
  showTillNumberDialog: boolean = false;
  tillNumber: string = '';

  // Notes
  showNotesDialog: boolean = false;
  orderNotes: string = '';

  // Discount / voucher
  showDiscountSection: boolean = false;
  showVoucherSection: boolean = false;
  discountMode: string = 'code';
  discountModeOptions = [
    { label: 'Discount Code', value: 'code' },
    { label: 'Open Amount', value: 'open' }
  ];
  discountCode: string = '';
  openDiscountAmount: number = 0;
  voucherCode: string = '';
  voucherPin: string = '';
  appliedDiscountTotal: number = 0;

  tillsale: cTillSale = {} as cTillSale;

  PaymentTypes: any[] = [];
  get cashPaymentType(): any {
    return this.PaymentTypes.find(pt => pt.name?.toLowerCase() === 'cash') ?? this.PaymentTypes[0] ?? null;
  }

  get existingPaidTotal(): number {
    return (this.tillsale?.payments ?? [])
      .filter((p: any) => !p.disabled)
      .reduce((sum: number, p: any) => sum + (p.amount ?? 0), 0);
  }

  get outstandingTotal(): number {
    return Math.max(0, this.TillRoleTotal - this.existingPaidTotal);
  }

  // Tab system
  openTabs: any[] = [];
  activeTabSaleId: string | null = null;
  activeTabData: any = null;
  showTabNameDialog: boolean = false;
  tabName: string = '';

  // Till name prompt
  showTillNamePrompt: boolean = false;
  tillNameInput: string = '';

  // Admin override
  currentUser: any = null;
  showAdminOverride: boolean = false;
  adminOverrideUsers: venueuser[] = [];
  adminOverrideSelectedId: string = '';
  adminOverridePin: string = '';
  adminOverridePending: (() => void) | null = null;

  private broadcastChannel = new BroadcastChannel('till_updates');

  terminalHubConnection: HubConnection | null = null;
  awaitingTerminalPayment: boolean = false;
  showPaymentFailedDialog: boolean = false;
  paymentFailedMessage: string = '';
  showTerminalBusyDialog: boolean = false;
  private pendingTerminalPayload: any = null;
  private pendingTerminalRetry: (() => void) | null = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private globalService: GlobalService,
    private auth: AuthService,
    private ngZone: NgZone,
    public drawerService: DrawerService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {

    this.PaymentTypes = JSON.parse(localStorage.getItem("PaymentTypes") || '[]');

    this.globalService.setSmallScreenMenu(false);

    //DRAWER KICKING SWITCHED OFF (22/10/26) - Web Bluetooth does not work on iPads and its chooser
    //can leave the page unclickable. Kept for a later rework; the drawer now opens from the
    //receipt printer's driver when a receipt prints.
    //Picks a drawer the browser has already been permitted to use back up, so the till
    //comes up connected after a reload without anyone pressing Connect again.
    //this.drawerService.restoreConnection();

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;
        this.currentUser = user;

        if(true){
          this.AccessAllowed = true;

          if (!localStorage.getItem(`TillName_${this.VenueID}`) || localStorage.getItem(`TillName_${this.VenueID}`)!.trim() === '') {
            this.showTillNamePrompt = true;
          }

              //Build Temp Till Data
    this.Departments = [];
    this.Products = [];
    this.tillRole = [];
    this.deptProducts = [];

    this.http.get(bmxurl + "/TillDepartmentsList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.Departments = (this.httpResponse.data as departments[]);
        this.http.get(bmxurl + "/TillProductList/" + this.VenueID + "/false").subscribe(response => {
          this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.Products = (this.httpResponse.data as any[]).map(p => ({
              ...p,
              departmentId: p.departmentId ?? p.departmentid ?? p.tilldepartment?.id ?? p.tilldepartment?.Id ?? ''
            }));

            if ((response as tillproducts_returndata).messages.length > 0)
        {
          (response as tillproducts_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Products, error: ' + this.httpResponse.messages[0]});
          }

          this.ShowProductsForDept();
          this.DataLoaded = true;

          const editSaleJson = sessionStorage.getItem('editTillSale');
          if (editSaleJson) {
            sessionStorage.removeItem('editTillSale');
            try {
              this.loadTab(JSON.parse(editSaleJson));
            } catch {}
          } else {
            this.loadOpenTabs();
          }

        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Products, error: ' + error.messages});
        });
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Departments, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Departments, error: ' + error.messages});
    });
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

  ngOnDestroy(): void {
    this.broadcastChannel.close();
    if (this.terminalHubConnection) {
      this.terminalHubConnection.stop();
      this.terminalHubConnection = null;
    }
    const doc = this.document as any;
    if (doc.exitFullscreen && doc.fullscreenElement) {
      doc.exitFullscreen().catch(() => {});
    } else if (doc.webkitExitFullscreen && doc.webkitFullscreenElement) {
      doc.webkitExitFullscreen();
    }
  }

  goToTransactions(): void {
    this.router.navigateByUrl('/tillsalemanager');
  }

  exitTill(): void {
    const doc = this.document as any;
    if (doc.exitFullscreen) {
      doc.exitFullscreen().catch(() => {});
    } else if (doc.webkitExitFullscreen) {
      doc.webkitExitFullscreen();
    }
    this.router.navigateByUrl('/home');
  }

  initPay(){
    if (this.activeTabSaleId) {
      // Table number and tab name are already on the sale object
      this.tillNumber = this.tillsale.tablenumber ?? '';
      this.pay();
    } else if (this.tillRole.some(x => x.kitchenitem)) {
      this.tillNumber = '';
      this.showTillNumberDialog = true;
    } else {
      this.pay();
    }
  }

  confirmTillName(): void {
    if (!this.tillNameInput || this.tillNameInput.trim() === '') {
      this.messageService.add({severity:'warn', summary:'Till Name Required', detail:'Please enter a name for this till.'});
      return;
    }
    localStorage.setItem(`TillName_${this.VenueID}`, this.tillNameInput.trim());
    this.showTillNamePrompt = false;
  }

  confirmTillNumber(){
    if (!this.tillNumber || this.tillNumber.trim() === '') {
      this.messageService.add({severity:'warn', summary:'Table Number Required', detail:'Please enter a table number for kitchen items.'});
      return;
    }
    this.showTillNumberDialog = false;
    this.pay();
  }

  pay(){
    this.TotalCost = this.outstandingTotal;
    this.Amount = this.TotalCost;

    if (this.activeTabSaleId) {
      this.tillsale.products = this.tillRole.map(item => this.toApiProduct(item)) as any;
      this.tillsale.total = this.TillRoleTotal;
      this.tillsale.lastupdated = new Date();

      this.http.put<any>(bmxurl + '/tillsale', this.tillsale).subscribe({
        next: (response) => {
          if (response.succeeded) {
            this.tillsale = response.data as cTillSale;
            this.captureMagicNumber(this.tillsale);
            this.tillsale.products = this.tillRole.map(item => this.toApiProduct(item)) as any;
            this.displayModal = true;
            this.setPaymentInputMode();
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not update order.' });
          }
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not update order.' });
        }
      });
      return;
    }

    this.displayModal = true;
    this.setPaymentInputMode();

    if (this.tillsale.tillsaleid) {
      // Existing sale — update products/total and stamp lastupdated
      this.tillsale.products = this.tillRole.map(item => this.toApiProduct(item)) as any;
      this.tillsale.total = this.TillRoleTotal;
      this.tillsale.lastupdated = new Date();

      this.http.put<any>(bmxurl + "/tillsale", this.tillsale).subscribe(response => {
        this.httpResponse = response;
        if (this.httpResponse.succeeded) {
          this.tillsale = this.httpResponse.data as cTillSale;
          this.captureMagicNumber(this.tillsale);
          this.tillsale.products = this.tillRole.map(item => this.toApiProduct(item)) as any;
        } else {
          this.messageService.add({severity:'error', summary:'Transaction unsuccessful', detail:this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Transaction unsuccessful', detail:error.messages});
      });
      return;
    }

    // New sale — createddate and lastupdated start identical
    let tsMonth = ('00' + (new Date().getMonth() + 1)).slice(-2);
    let tsDay = ('00' + new Date().getDate()).slice(-2);
    let tsYear = new Date().getFullYear().toString();
    let venueDate = this.VenueID + "_" + tsDay + tsMonth + tsYear;
    const now = new Date();

    this.tillsale = {
      id: null,
      tillsaleid: null,
      venueid: this.VenueID,
      venuedate: venueDate,
      userid: localStorage.getItem("SmartUserID")!,
      createddate: now,
      lastupdated: now,
      total: this.TillRoleTotal,
      payments: [],
      notes: this.orderNotes,
      products: this.tillRole.map(item => this.toApiProduct(item)) as any,
      voided: false,
      disabled: false,
      tablenumber: this.tillNumber,
      priority: false,
      tillname: localStorage.getItem(`TillName_${this.VenueID}`) ?? '',
      tabname: '',
      kitchencomplete: false,
      istab: false,
      //Placeholder - the API fills this in and hands it back on the response.
      magicnumber: null
    }

    this.http.post<any>(bmxurl + "/tillsale", this.tillsale).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        this.tillsale = this.httpResponse.data as cTillSale;
        this.captureMagicNumber(this.tillsale);
        this.tillsale.products = this.tillRole.map(item => this.toApiProduct(item)) as any;
      } else {
        this.messageService.add({severity:'error', summary:'Transaction unsuccessful', detail:this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Transaction unsuccessful', detail:error.messages});
    });

  }

  //Cash off ends the sale, so the till sale object has to be dropped as well as the roll.
  //pay() treats a populated tillsaleid as "this is an existing order" and PUTs to it, so
  //leaving it in place made the next order update the sale that was just paid for instead
  //of creating a new one - which is why the Kitchen Display System kept amending the same
  //order rather than showing a new one.
  //paymentMethod is what the last payment was taken by, for the receipt; none when nothing was
  //left to pay.
  private finishSale(paymentMethod: string = ''): void {
    //Every cash off path lands here, so the receipt prints from here - before the sale is
    //cleared, while its items and totals are still to hand.
    this.printSaleReceipt(paymentMethod);

    this.tillsale = {} as cTillSale;
    this.tillRole = [];
    this.TillRoleTotal = 0;
    this.resetDiscountState();

    //DRAWER KICKING SWITCHED OFF (22/10/26) - see ngOnInit. The receipt printer's driver
    //opens the drawer when the receipt above prints.
    //Every cash off path lands here, so this is where the drawer kicks. It stays quiet
    //until a drawer has been picked once from the No Sale button, because this runs after
    //a payment response rather than inside a click and the chooser needs a user gesture.
    //this.drawerService.openDrawerIfPaired();
  }

  removeTillItem(prod){
    if (this.expandedItem === prod) this.expandedItem = null;
    this.tillRole = this.tillRole.filter(x => x !== prod);
    this.TillRoleTotal = this.tillRole.reduce((sum, r) => sum + r.price, 0);
  }

  selectDept(idx: number): void {
    this.selectedIndex = idx;
    this.expandedItem = null;
    this.ShowProductsForDept();
  }

  toggleExpand(item: tillRoll): void {
    this.expandedItem = this.expandedItem === item ? null : item;
  }

  changeQty(item: tillRoll, delta: number, event: Event): void {
    event.stopPropagation();
    const prod = item.product as any;
    const optionsPrice = (item.selectedOptions ?? []).reduce((s: number, o: any) => s + (o.price ?? 0), 0);
    const unitPrice = (prod.price ?? 0) + optionsPrice;
    item.qty += delta;
    if (item.qty <= 0) {
      this.removeTillItem(item);
    } else {
      item.price = unitPrice * item.qty;
      this.TillRoleTotal = this.tillRole.reduce((sum, r) => sum + r.price, 0);
    }
  }

  addProduct(prod: cTillproduct): void {
    if (prod.options?.length > 0) {
      this.pendingProduct = prod;
      this.selectedOptions = [];
      this.showOptionsDialog = true;
    } else {
      this.commitProduct(prod, []);
    }
  }

  editTillRollOptions(item: tillRoll): void {
    this.editingTillRollItem = item;
    this.pendingProduct = item.product;
    this.selectedOptions = [...(item.selectedOptions ?? [])];
    this.showOptionsDialog = true;
  }

  confirmAddWithOptions(): void {
    if (this.editingTillRollItem) {
      const optionsPrice = this.selectedOptions.reduce((sum, o) => sum + (o.price ?? 0), 0);
      const unitPrice = this.editingTillRollItem.product.price;
      this.editingTillRollItem.selectedOptions = [...this.selectedOptions];
      this.editingTillRollItem.price = (unitPrice + optionsPrice) * this.editingTillRollItem.qty;
      this.TillRoleTotal = this.tillRole.reduce((sum, r) => sum + r.price, 0);
    } else if (this.pendingProduct) {
      this.commitProduct(this.pendingProduct, this.selectedOptions);
    }
    this.showOptionsDialog = false;
    this.pendingProduct = null;
    this.selectedOptions = [];
    this.editingTillRollItem = null;
  }

  cancelOptionsDialog(): void {
    this.showOptionsDialog = false;
    this.pendingProduct = null;
    this.selectedOptions = [];
    this.editingTillRollItem = null;
    this.expandedItem = null;
  }

  private sameOptions(a: tillproductoptions[], b: tillproductoptions[]): boolean {
    if (a.length !== b.length) return false;
    const ids = (opts: tillproductoptions[]) =>
      opts.map(o => o.id ?? o.name).sort().join('|');
    return ids(a) === ids(b);
  }

  private commitProduct(prod: cTillproduct, options: tillproductoptions[]): void {
    const optionsPrice = options.reduce((sum, o) => sum + (o.price ?? 0), 0);
    const linePrice = prod.price + optionsPrice;

    // Merge if same product and same option combination
    const existing = this.tillRole.find(x =>
      x.id === (prod.id ?? prod.tillproductid ?? '') &&
      this.sameOptions(x.selectedOptions ?? [], options)
    );
    if (existing) {
      existing.qty++;
      existing.price += linePrice;
      this.TillRoleTotal += linePrice;
      return;
    }

    this.tillRole.push({
      qty: 1,
      product: prod,
      disabled: false,
      venueid: this.VenueID,
      id: prod.id ?? prod.tillproductid ?? '',
      price: linePrice,
      kitchenitem: prod.kitchenitem,
      selectedOptions: options.length > 0 ? [...options] : []
    });

    this.TillRoleTotal += linePrice;
  }

  ShowProductsForDept(event?: any)
  {
    const idx = (event?.index !== undefined) ? event.index : this.selectedIndex;
    let deptId: any = this.Departments[idx].id;
    this.deptProducts = this.Products.filter(x =>
      x.departmentId == deptId ||
      (x as any).tilldepartment?.tilldepartmentid == deptId ||
      (x as any).tilldepartment?.id == deptId
    );
  }

  payOff(amount: number, paymentType: any)
  {
    if(amount > this.TotalCost && paymentType?.name?.toLowerCase() !== 'cash')
    {
      this.displayModalOverPaymentWarning = true;
    }
    else
    {
      const paidTabId = this.activeTabSaleId;

      if(this.TotalCost > 0)
      {
        const terminalName = localStorage.getItem(`TerminalName_${this.VenueID}`) ?? '';
        const isCardPayment = (paymentType?.name ?? '').toLowerCase().includes('card');

        if (isCardPayment && terminalName)
        {
          const terminalPayload = {
            venueid: this.VenueID,
            connectedAccountId: localStorage.getItem("RyftSubAccountID") ?? '',
            amount: Math.round(this.TotalCost * 100),
            currency: this.CurrencySymbol.toLowerCase(),
            terminalId: terminalName,
            method: 'TILLSALE',
            identifier: this.tillsale.tillsaleid ?? ''
          };

          this.initiateTillTerminalPayment(terminalPayload, amount, paymentType, paidTabId);
        }
        else
        {
          const payment: cTillSalePayment = {
            id: null,
            paymentid: '',
            tillsaleid: this.tillsale.tillsaleid ?? '',
            tillsaleidhr: this.tillsale.tillsaleidhr ?? '',
            method: paymentType?.name ?? '',
            paymenttypeid: paymentType?.id ?? '',
            amount: this.TotalCost,
            paymentDate: new Date(),
            disabled: false,
            venueid: this.VenueID,
            refunds: [],
            balance: this.TotalCost,
            paymenttype: paymentType?.name ?? '',
            currency: this.CurrencySymbol,
            tillname: localStorage.getItem(`TillName_${this.VenueID}`) ?? ''
          };

          this.http.post<any>(bmxurl + "TillSalePayment", payment).subscribe(response => {
            this.httpResponse = response;
            if(this.httpResponse.succeeded)
            {
              this.broadcastChannel.postMessage({ type: 'sale_updated' });
              this.messageService.add({severity:'success', summary:'Started', detail:'Transaction Successful.'});
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Transaction unsuccessful', detail:this.httpResponse.messages[0]});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Transaction unsuccessful', detail:error.messages});
          });

          this.Change = amount - this.TotalCost;
          this.pendingReceiptItems = [...this.tillRole];
          this.displayModalChange = true;
          this.displayModal = false;
          this.finishSale(paymentType?.name ?? '');
          if (paidTabId) { this.openTabs = this.openTabs.filter(t => t.tillsaleid !== paidTabId); localStorage.removeItem('tabOptions_' + paidTabId); }
        }
      }
      else if(this.TotalCost == 0)
      {
        this.Change = 0;
        this.pendingReceiptItems = [...this.tillRole];
        this.displayModalChange = true;
        this.displayModal = false;
        this.finishSale();
        if (paidTabId) { this.openTabs = this.openTabs.filter(t => t.tillsaleid !== paidTabId); localStorage.removeItem('tabOptions_' + paidTabId); }
      }
      else if (this.TotalCost < 0)
      {
        this.Change = ((this.TotalCost) * -1);
        this.pendingReceiptItems = [...this.tillRole];
        this.displayModalChange = true;
        this.TotalCost = 0;
        this.displayModal = false;
        this.finishSale();
        if (paidTabId) { this.openTabs = this.openTabs.filter(t => t.tillsaleid !== paidTabId); localStorage.removeItem('tabOptions_' + paidTabId); }
      }
    }
  }

  private initiateTillTerminalPayment(terminalPayload: any, amount: number, paymentType: any, paidTabId: string | null): void {
    this.http.post<any>(bmxurl + "StripeTerminalPaymentInit", terminalPayload).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded)
      {
        const paymentIntentId: string = this.httpResponse.data?.paymentIntentId ?? this.httpResponse.data?.id ?? '';
        this.displayModal = false;
        this.connectTerminalHub(paymentIntentId, amount, paymentType?.name ?? '', paidTabId);
      }
      else
      {
        const detail = this.httpResponse.messages?.[0] ?? 'Unknown error';
        if (detail.toLowerCase().includes('payment_intent in progress'))
        {
          this.pendingTerminalPayload = terminalPayload;
          this.pendingTerminalRetry = () => this.initiateTillTerminalPayment(terminalPayload, amount, paymentType, paidTabId);
          this.showTerminalBusyDialog = true;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Terminal payment failed', detail});
        }
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Terminal payment failed', detail:error.message});
    });
  }

  waitForTerminal(): void {
    this.showTerminalBusyDialog = false;
  }

  clearTerminalAndRetryPayment(): void {
    const terminalId = this.pendingTerminalPayload?.terminalId ?? '';
    this.showTerminalBusyDialog = false;
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.pendingTerminalRetry?.();
      }
    });
  }

  cancelTerminalPayment(): void {
    if (this.terminalHubConnection) {
      this.terminalHubConnection.stop();
      this.terminalHubConnection = null;
    }
    this.awaitingTerminalPayment = false;
    this.displayModal = true;

    const terminalId = localStorage.getItem(`TerminalName_${this.VenueID}`) ?? '';
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {}
    });
  }

  connectTerminalHub(paymentIntentId: string, amount: number, paymentTypeName: string, paidTabId: string | null): void {
    this.awaitingTerminalPayment = true;

    this.auth.getAccessTokenSilently().subscribe({
      next: (token) => {
        const hub = new HubConnectionBuilder()
          .withUrl(environment.servicestarget + "/venue/" + this.VenueID, {
            accessTokenFactory: () => token
          })
          .build();

        this.terminalHubConnection = hub;

        // Register handler BEFORE start() so no messages are missed.
        // ngZone.run() is required — SignalR callbacks fire outside Angular's zone
        // so without it property changes won't trigger change detection.
        hub.on(paymentIntentId, (message: string) => {
          this.ngZone.run(() => {
            hub.stop();
            this.terminalHubConnection = null;
            this.awaitingTerminalPayment = false;

            if (message === 'succeeded') {
              this.broadcastChannel.postMessage({ type: 'sale_updated' });
              this.messageService.add({ severity: 'success', summary: 'Payment Succeeded', detail: 'Card payment completed successfully.' });
              this.Change = amount - this.TotalCost;
              this.pendingReceiptItems = [...this.tillRole];
              this.displayModalChange = true;
              this.finishSale(paymentTypeName);
              if (paidTabId) { this.openTabs = this.openTabs.filter(t => t.tillsaleid !== paidTabId); localStorage.removeItem('tabOptions_' + paidTabId); }
            } else {
              this.paymentFailedMessage = message;
              this.showPaymentFailedDialog = true;
            }
          });
        });

        hub.start().catch(() => {
          this.terminalHubConnection = null;
          this.awaitingTerminalPayment = false;
          this.messageService.add({ severity: 'error', summary: 'Connection Error', detail: 'Could not connect to payment service.' });
          this.displayModal = true;
        });
      },
      error: () => {
        this.awaitingTerminalPayment = false;
        this.messageService.add({ severity: 'error', summary: 'Auth Error', detail: 'Could not authenticate for payment service.' });
        this.displayModal = true;
      }
    });
  }

  getPaymentIcon(name: string): string {
    const n = (name ?? '').toLowerCase();
    if (n === 'cash') {
      if (this.CurrencySymbol === 'USD') return 'pi-dollar';
      if (this.CurrencySymbol === 'EUR') return 'pi-euro';
      return 'pi-pound';
    }
    if (n.includes('card') || n.includes('credit') || n.includes('debit')) return 'pi-credit-card';
    if (n.includes('voucher') || n.includes('gift')) return 'pi-gift';
    if (n.includes('bank') || n.includes('transfer') || n.includes('bacs')) return 'pi-building';
    if (n.includes('cheque') || n.includes('check')) return 'pi-pencil';
    return 'pi-wallet';
  }

  resetDiscountState(): void {
    this.discountCode = '';
    this.openDiscountAmount = 0;
    this.voucherCode = '';
    this.voucherPin = '';
    this.appliedDiscountTotal = 0;
    this.showDiscountSection = false;
    this.showVoucherSection = false;
    this.tillNumber = '';
    this.orderNotes = '';
    this.activeTabSaleId = null;
    this.activeTabData = null;
  }

  openTabDialog(): void {
    this.displayModal = false;
    if (this.activeTabSaleId && this.tillsale.tabname) {
      this.saveToTab(this.tillsale.tabname);
    } else {
      this.tabName = '';
      this.showTabNameDialog = true;
    }
  }

  cancelTabDialog(): void {
    this.showTabNameDialog = false;
    this.displayModal = true;
  }

  confirmPutOnTab(): void {
    if (!this.tabName || this.tabName.trim() === '') {
      this.messageService.add({severity:'warn', summary:'Name Required', detail:'Please enter a name for this tab.'});
      return;
    }
    this.saveToTab(this.tabName.trim());
  }

  cancelTabEdit(): void {
    this.tillRole = [];
    this.TillRoleTotal = 0;
    this.activeTabSaleId = null;
    this.activeTabData = null;
    this.tillsale = {} as cTillSale;
    this.resetDiscountState();
  }

  updateTab(): void {
    this.tillsale.products = this.tillRole.map(item => this.toApiProduct(item)) as any;
    this.tillsale.total = this.TillRoleTotal;
    const productsSnapshot: any[] = JSON.parse(JSON.stringify(this.tillRole));

    this.http.put<any>(bmxurl + "/tillsale", this.tillsale).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        const saved = this.httpResponse.data;
        const tabWithOptions = {
          ...saved,
          products: (saved.products ?? []).map((apiProd: any, idx: number) => ({
            ...apiProd,
            selectedOptions: productsSnapshot[idx]?.selectedOptions ?? []
          }))
        };
        localStorage.setItem('tabOptions_' + saved.tillsaleid, JSON.stringify(
          productsSnapshot.map((p: any) => ({ id: p.id, selectedOptions: p.selectedOptions ?? [] }))
        ));
        const existing = this.openTabs.findIndex(t => t.tillsaleid === saved.tillsaleid);
        if (existing >= 0) {
          this.openTabs = this.openTabs.map((t, i) => i === existing ? tabWithOptions : t);
        } else {
          this.openTabs = [...this.openTabs, tabWithOptions];
        }
        this.broadcastChannel.postMessage({ type: 'sale_updated' });
        this.tillRole = [];
        this.TillRoleTotal = 0;
        this.resetDiscountState();
        this.messageService.add({ severity: 'success', summary: 'Tab Updated', detail: 'Tab updated for ' + (this.tillsale.tabname || 'tab') });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not update tab.' });
      }
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not update tab.' });
    });
  }

  private saveToTab(tabname: string): void {
    this.tillsale.tabname = tabname;
    this.tillsale.istab = true;
    this.tillsale.products = this.tillRole.map(item => this.toApiProduct(item)) as any;
    const productsSnapshot: any[] = JSON.parse(JSON.stringify(this.tillRole));

    this.http.put<any>(bmxurl + "/tillsale", this.tillsale).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        const saved = this.httpResponse.data;

        // Merge selectedOptions from our snapshot back into the API response
        // (the API does not round-trip selectedOptions)
        const tabWithOptions = {
          ...saved,
          products: (saved.products ?? []).map((apiProd: any, idx: number) => ({
            ...apiProd,
            selectedOptions: productsSnapshot[idx]?.selectedOptions ?? []
          }))
        };

        // Also persist to localStorage so they survive a page reload / loadOpenTabs()
        localStorage.setItem('tabOptions_' + saved.tillsaleid, JSON.stringify(
          productsSnapshot.map((p: any) => ({ id: p.id, selectedOptions: p.selectedOptions ?? [] }))
        ));

        const existing = this.openTabs.findIndex(t => t.tillsaleid === tabWithOptions.tillsaleid);
        if (existing >= 0) {
          this.openTabs = this.openTabs.map((t, i) => i === existing ? tabWithOptions : t);
        } else {
          this.openTabs = [...this.openTabs, tabWithOptions];
        }
        this.broadcastChannel.postMessage({ type: 'sale_updated' });
        this.showTabNameDialog = false;
        this.tabName = '';
        this.tillRole = [];
        this.TillRoleTotal = 0;
        this.resetDiscountState();
        this.messageService.add({severity:'success', summary:'On Tab', detail:'Order saved to tab for ' + tabname});
      } else {
        this.messageService.add({severity:'error', summary:'Error', detail:'Could not save tab.'});
      }
    }, () => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Could not save tab.'});
    });
  }

  loadTab(tab: any): void {
    // Try localStorage first (survives API round-trips that strip selectedOptions)
    const storedJson = localStorage.getItem('tabOptions_' + tab.tillsaleid);
    const storedOptions: any[] = storedJson ? JSON.parse(storedJson) : [];

    this.tillRole = (tab.products ?? []).map((p: any, idx: number) => {
      const fullProduct = this.Products.find(prod =>
        (prod.id ?? prod.tillproductid) === p.id
      ) ?? p.product;

      // Preference order: API field (camelCase) → API field (PascalCase) →
      // openTabs merged data already on p → localStorage by product id → localStorage by index
      const fromStorage =
        storedOptions.find((s: any) => s.id === p.id) ??
        storedOptions.find((s: any) => s.id === (p.product?.id ?? p.product?.tillproductid)) ??
        storedOptions[idx];

      const selectedOptions: any[] =
        (p.selectedOptions?.length > 0 ? p.selectedOptions : null) ??
        (p.SelectedOptions?.length > 0 ? p.SelectedOptions : null) ??
        fromStorage?.selectedOptions ??
        (p.options?.length > 0 ? p.options : []);

      return { ...p, product: fullProduct, selectedOptions, qty: p.qty ?? 1 };
    });
    this.TillRoleTotal = tab.total;
    this.activeTabSaleId = tab.tillsaleid;
    this.activeTabData = { ...tab };
    this.tillsale = { ...tab };
  }

  loadOpenTabs(): void {
    this.http.get<any>(bmxurl + "TillSaleList/" + this.VenueID).subscribe(response => {
      if (response && response.succeeded && response.data) {
        this.openTabs = (response.data as any[]).filter(s =>
          !!s.istab && !s.voided && !s.disabled &&
          (!s.payments || s.payments.length === 0)
        );
      }
    });
  }

  cancelPay(): void {
    this.displayModal = false;
    if (this.activeTabSaleId) {
      this.tillRole = [];
      this.TillRoleTotal = 0;
      this.resetDiscountState();
    }
  }

  requestVoid(): void {
    this.displayModal = false;
    this.showVoidConfirm = true;
  }

  confirmVoid(): void {
    this.tillsale.voided = true;
    this.showVoidConfirm = false;
    this.http.post<any>(bmxurl + 'tillsale', this.tillsale).subscribe({
      next: (response) => {
        if (response.succeeded) {
          this.messageService.add({ severity: 'info', summary: 'Voided', detail: 'Transaction has been voided.' });
          this.tillRole = [];
          this.TillRoleTotal = 0;
          this.activeTabSaleId = null;
          this.activeTabData = null;
          this.tillsale = {} as cTillSale;
          this.resetDiscountState();
          this.loadOpenTabs();
        } else {
          this.tillsale.voided = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not void transaction.' });
        }
      },
      error: () => {
        this.tillsale.voided = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not void transaction.' });
      }
    });
  }

  cancelVoid(): void {
    this.showVoidConfirm = false;
    this.displayModal = true;
  }

  applyDiscount(): void {
    const sale = this.buildCurrentSale();
    if (this.discountMode === 'code') {
      const payload: cTillsaleDiscountvalidate = { tillsale: sale, discountcode: this.discountCode.trim() };
      this.http.post<any>(bmxurl + 'TillDiscountValidate', payload).subscribe({
        next: (response) => {
          if (response.succeeded) {
            this.appliedDiscountTotal += response.data?.discountamount ?? 0;
            this.TotalCost = Math.max(0, this.TillRoleTotal - this.appliedDiscountTotal);
            this.discountCode = '';
            this.showDiscountSection = false;
            this.messageService.add({ severity: 'success', summary: 'Discount Applied', detail: 'Discount code accepted.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Invalid Code', detail: response.messages?.[0] ?? 'Discount code not recognised.' });
          }
        },
        error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not validate discount code.' })
      });
    } else {
      if (!this.openDiscountAmount || this.openDiscountAmount <= 0) {
        this.messageService.add({ severity: 'warn', summary: 'Invalid Amount', detail: 'Please enter a discount amount greater than zero.' });
        return;
      }
      this.appliedDiscountTotal += this.openDiscountAmount;
      this.TotalCost = Math.max(0, this.TillRoleTotal - this.appliedDiscountTotal);
      this.openDiscountAmount = 0;
      this.showDiscountSection = false;
      this.messageService.add({ severity: 'success', summary: 'Discount Applied', detail: 'Discount applied successfully.' });
    }
  }

  applyVoucher(): void {
    const sale = this.buildCurrentSale();
    const payload: cTillsaleVouchervalidate = { tillsale: sale, vouchercode: this.voucherCode.trim(), voucherpin: this.voucherPin };
    this.http.post<any>(bmxurl + 'TillVoucherValidate', payload).subscribe({
      next: (response) => {
        if (response.succeeded) {
          const voucherValue = response.data?.balance ?? response.data?.value ?? 0;
          this.appliedDiscountTotal += voucherValue;
          this.TotalCost = Math.max(0, this.TillRoleTotal - this.appliedDiscountTotal);
          this.voucherCode = '';
          this.voucherPin = '';
          this.showVoucherSection = false;
          this.messageService.add({ severity: 'success', summary: 'Voucher Applied', detail: 'Gift voucher accepted.' });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Invalid Voucher', detail: response.messages?.[0] ?? 'Voucher code or PIN not recognised.' });
        }
      },
      error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not validate voucher.' })
    });
  }

  private toApiProduct(item: tillRoll): any {
    const prod = item.product as any;
    return {
      id: prod?.id ?? item.id,
      tillproductid: prod?.tillproductid ?? null,
      name: prod?.name ?? null,
      disabled: item.disabled,
      venueid: item.venueid,
      colour: prod?.colour ?? null,
      price: item.price,
      qty: item.qty,
      options: item.selectedOptions ?? [],
      tilldepartment: prod?.tilldepartment ?? null,
      departmentid: prod?.departmentid ?? prod?.departmentId ?? null,
      kitchenitem: item.kitchenitem
    };
  }

  private setPaymentInputMode(): void {
    setTimeout(() => {
      const el = document.getElementById('tillPaymentAmount') as HTMLInputElement | null;
      if (el) el.setAttribute('inputmode', 'decimal');
    }, 0);
  }

  private buildCurrentSale(): cTillSale {
    const tsMonth = ('00' + (new Date().getMonth() + 1)).slice(-2);
    const tsDay = ('00' + new Date().getDate()).slice(-2);
    const tsYear = new Date().getFullYear().toString();
    return {
      id: '', tillsaleid: '', venueid: this.VenueID,
      venuedate: this.VenueID + '_' + tsDay + tsMonth + tsYear,
      userid: localStorage.getItem('SmartUserID')!,
      createddate: new Date(), total: this.TillRoleTotal,
      payments: [], notes: '', products: this.tillRole,
      voided: false, disabled: false, tablenumber: this.tillNumber, priority: false, tillname: localStorage.getItem(`TillName_${this.VenueID}`) ?? '', tabname: '', kitchencomplete: false, istab: false
    };
  }

  //The change dialog is the last thing every cash off path shows, so hanging the prep list
  //off its dismissal covers cash, card, terminal and zero value sales in one place without
  //the two dialogs ever stacking on top of each other.
  closeChangeDialog(): void {
    this.displayModalChange = false;

    //Opening the next modal in the same tick leaves the closing dialog's mask behind - an
    //invisible full screen layer that swallows every click on the till. Waiting for the
    //close to finish first lets PrimeNG tear its mask down before the next one goes up.
    setTimeout(() => this.showServerItems(), 300);
  }

  private showServerItems(): void {
    this.serverItemsCompleted = [];
    this.serverItemsOutstanding = this.buildServerItems(this.pendingReceiptItems);
    this.displayModalServerItems = this.serverItemsOutstanding.length > 0;
  }

  //Groups by product and option combination so two identical coffees show as "2 x Latte"
  //rather than two separate rows. Recalled tabs can carry the kitchen flag on either the
  //line or the product, which is the same pair the Kitchen Display System checks.
  private buildServerItems(items: tillRoll[]): { name: string, options: string, qty: number }[] {
    let grouped = new Map<string, { name: string, options: string, qty: number }>();

    (items ?? [])
      .filter(item => !(item.kitchenitem || item.product?.kitchenitem))
      .forEach(item => {
        let options = (item.selectedOptions ?? []).map(o => o.name).join(', ');
        let name = item.product?.name ?? '';
        let key = name + '|' + options;

        let existing = grouped.get(key);

        if (existing) {
          existing.qty += (item.qty ?? 1);
        }
        else {
          grouped.set(key, { name: name, options: options, qty: (item.qty ?? 1) });
        }
      });

    return Array.from(grouped.values());
  }

  completeServerItem(item: { name: string, options: string, qty: number }): void {
    this.serverItemsOutstanding = this.serverItemsOutstanding.filter(i => i !== item);
    this.serverItemsCompleted.push(item);
  }

  //Closing the dialog throws the list away, so a mis-tap would otherwise be unrecoverable.
  undoServerItem(item: { name: string, options: string, qty: number }): void {
    this.serverItemsCompleted = this.serverItemsCompleted.filter(i => i !== item);
    this.serverItemsOutstanding.push(item);
  }

  closeServerItems(): void {
    this.displayModalServerItems = false;
  }

  noSale(): void {
    this.requireAdminApproval(() => this.executeNoSale());
  }

  //TEMPORARY - stands in for the API so the band can be seen before real numbers arrive.
  //Delete this constant and the fallback in captureMagicNumber() once the API is live.
  private readonly DEMO_MAGIC_NUMBER = 'DEMO-12345';

  //The API stamps a magic number on the sale when it saves it. Nothing shows until it
  //starts coming back on the response, and a repeat of the same number is ignored so the
  //band doesn't reappear once it has been dismissed for that sale.
  private captureMagicNumber(sale: cTillSale): void {
    //A tab isn't finished business - the number belongs to the receipt, so it waits until
    //the tab is paid off rather than showing every time the tab is saved.
    if (sale?.istab) {
      return;
    }

    const number = (sale?.magicnumber ?? '').toString().trim()
      || this.DEMO_MAGIC_NUMBER; //TEMPORARY - drop this fallback when the API is live.

    if (number == '' || number == this.magicNumber) {
      return;
    }

    this.magicNumber = number;
    this.showMagicNumber = true;
  }

  dismissMagicNumber(): void {
    this.showMagicNumber = false;
  }

  //DRAWER KICKING SWITCHED OFF (22/10/26) - see ngOnInit. Its Connect button is commented out of
  //the page too.
  connectDrawer(): void {
    //These callbacks resume after an await on a Web Bluetooth promise. The build targets
    //ES2022, so async/await is native and zone.js cannot follow it - anything here would
    //otherwise run outside Angular's zone, where touching the UI neither repaints nor
    //schedules change detection. The screen then looks frozen even though clicks are
    //landing, which is indistinguishable from something invisible sitting over the page.
    //connect() is openDrawer() without the pulse - same synchronous route to the chooser
    //and the same retry, so it connects without the till springing open.
    // this.drawerService.connect().then(ok => {
    //   this.ngZone.run(() => {
    //     if (ok) {
    //       this.drawerService.showMessage('success', 'Drawer Connected', 'The cash drawer is connected.');
    //     }
    //   });
    // });
  }

  //No Sale prints a "NO SALE" slip, which is what opens the drawer now - the receipt printer's
  //driver opens it on every print. With receipts off on this till there is nothing to open it.
  private executeNoSale(): void {
    //DRAWER KICKING SWITCHED OFF (22/10/26) - see ngOnInit.
    //Runs from the button press, so the browser will let us open the device chooser here if
    //no drawer has been picked yet.
    // this.drawerService.openDrawer().then(opened => {
    //   this.ngZone.run(() => {
    //     if (opened) {
    //       this.drawerService.showMessage('success', 'No Sale', 'No Sale, drawer opened');
    //     }
    //   });
    // });

    if (!this.printReceipts) {
      this.messageService.add({ severity: 'warn', summary: 'No Sale', detail: 'Receipt printing is off on this till, so the drawer cannot be opened from here.' });
      return;
    }

    this.printHtml(this.receiptPage(
      '<div class="big center">NO SALE</div>' +
      '<div class="center">' + this.escapeHtml(this.receiptDateTime()) + '</div>' +
      '<div class="center">' + this.escapeHtml(this.currentUser?.name ?? '') + '</div>'));

    this.messageService.add({ severity: 'success', summary: 'No Sale', detail: 'No Sale slip sent to the printer.' });
  }

  //#region Receipt printing
  //Receipts print with window.print() from a hidden frame. Started with Chrome or Edge's
  //--kiosk-printing switch, that goes straight to the default printer with no dialog - so the
  //receipt printer is made the default printer on the till PC. The cash drawer is opened by the
  //receipt printer's own driver ("open cash drawer" when printing), so every receipt opens it.
  //On or off per till, held on the device, since only a till set up that way should print - any
  //other would raise a print dialog on every sale.

  get printReceipts(): boolean {
    try {
      return localStorage.getItem('PrintReceipts_' + this.VenueID) == 'true';
    }
    catch {
      return false;
    }
  }

  togglePrintReceipts(): void {
    const on = !this.printReceipts;

    try {
      localStorage.setItem('PrintReceipts_' + this.VenueID, on ? 'true' : 'false');
    }
    catch {
      this.messageService.add({ severity: 'error', summary: 'Receipts', detail: 'This browser would not save the setting.' });
      return;
    }

    this.messageService.add({ severity: 'info', summary: 'Receipts', detail: on ? 'Receipts will print on this till.' : 'Receipts will not print on this till.' });
  }

  //Prints a test receipt, so the printer and the kiosk setting can be checked without a sale.
  printTestReceipt(): void {
    this.printHtml(this.receiptPage(
      this.receiptHeader() +
      '<div class="big center">TEST RECEIPT</div>' +
      '<div class="center">If this printed with no dialog, the till is set up.</div>'));
  }

  //The receipt for the sale being finished, built from what is still on the till.
  private printSaleReceipt(paymentMethod: string): void {
    if (!this.printReceipts) {
      return;
    }

    const items = this.tillRole ?? [];
    const subtotal = this.TillRoleTotal ?? 0;
    const discounts = this.appliedDiscountTotal ?? 0;
    const total = Math.max(0, subtotal - discounts);
    const change = Math.max(0, this.Change ?? 0);
    const paid = (this.TotalCost ?? 0) + change;

    let lines = '';

    items.forEach(item => {
      const options = (item.selectedOptions ?? []).map(o => o.name).filter(n => !!n).join(', ');

      lines += this.receiptRow((item.qty ?? 1) + ' x ' + (item.product?.name ?? ''), this.money(item.price));

      if (options != '') {
        lines += '<div class="opt">' + this.escapeHtml(options) + '</div>';
      }
    });

    let totals = '';

    if (discounts > 0) {
      totals += this.receiptRow('Subtotal', this.money(subtotal));
      totals += this.receiptRow('Discounts', '-' + this.money(discounts));
    }

    totals += '<div class="bold">' + this.receiptRow('TOTAL', this.money(total)) + '</div>';

    if (paymentMethod != '' && paid > 0) {
      totals += this.receiptRow('Paid by ' + paymentMethod, this.money(paid));
    }

    if (change > 0) {
      totals += this.receiptRow('Change', this.money(change));
    }

    //The demo number is a stand-in until the API sends real ones, so it never goes on paper.
    const magic = this.magicNumber != '' && this.magicNumber != this.DEMO_MAGIC_NUMBER ? this.magicNumber : '';

    this.printHtml(this.receiptPage(
      this.receiptHeader() +
      (this.tillsale?.tillsaleidhr ? '<div class="center">Sale ' + this.escapeHtml(this.tillsale.tillsaleidhr) + '</div>' : '') +
      '<hr>' + lines + '<hr>' + totals +
      (magic != '' ? '<hr><div class="center">Receipt Magic Number</div><div class="big center">' + this.escapeHtml(magic) + '</div>' : '') +
      '<hr><div class="center">Thank you</div>'));
  }

  private receiptHeader(): string {
    const venue = localStorage.getItem('SmartVenueName') ?? '';
    const till = localStorage.getItem('TillName_' + this.VenueID) ?? '';

    return (venue != '' ? '<div class="big center">' + this.escapeHtml(venue) + '</div>' : '') +
      '<div class="center">' + this.escapeHtml(this.receiptDateTime()) + (till != '' ? ' &middot; ' + this.escapeHtml(till) : '') + '</div>';
  }

  private receiptRow(left: string, right: string): string {
    return '<div class="row"><span>' + this.escapeHtml(left) + '</span><span>' + this.escapeHtml(right) + '</span></div>';
  }

  private receiptDateTime(): string {
    const now = new Date();
    const two = (n: number) => ('0' + n).slice(-2);
    return two(now.getDate()) + '/' + two(now.getMonth() + 1) + '/' + now.getFullYear() + ' ' + two(now.getHours()) + ':' + two(now.getMinutes());
  }

  private money(value: number): string {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.CurrencySymbol || 'GBP' }).format(Number(value) || 0);
    }
    catch {
      return (Number(value) || 0).toFixed(2);
    }
  }

  //Product, option, venue and till names are typed in by staff, so everything put on the receipt
  //is escaped rather than trusted as HTML.
  private escapeHtml(text: string): string {
    return (text ?? '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  //A whole receipt page, sized for 80mm paper (72mm printable).
  private receiptPage(body: string): string {
    return '<!doctype html><html><head><meta charset="utf-8"><title>Receipt</title><style>' +
      '@page { size: 80mm auto; margin: 0; }' +
      'html, body { margin: 0; padding: 0; }' +
      'body { width: 72mm; padding: 2mm 4mm 6mm; box-sizing: border-box; font-family: "Courier New", monospace; font-size: 12px; color: #000; }' +
      '.center { text-align: center; }' +
      '.big { font-size: 16px; font-weight: bold; margin: 2px 0; }' +
      '.bold { font-weight: bold; }' +
      '.row { display: flex; justify-content: space-between; gap: 6px; }' +
      '.row span:first-child { flex: 1; word-break: break-word; }' +
      '.row span:last-child { white-space: nowrap; }' +
      '.opt { padding-left: 10px; font-size: 11px; }' +
      'hr { border: none; border-top: 1px dashed #000; margin: 4px 0; }' +
      '</style></head><body>' + body + '</body></html>';
  }

  //Prints a page from a hidden frame, so the till itself is never what gets printed and is not
  //disturbed. The frame is taken away again once the print has gone.
  private printHtml(html: string): void {
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    document.body.appendChild(frame);

    const doc = frame.contentWindow?.document;

    if (doc == null) {
      frame.remove();
      return;
    }

    doc.open();
    doc.write(html);
    doc.close();

    //A moment for the page to lay out before it is printed.
    setTimeout(() => {
      try {
        frame.contentWindow?.focus();
        frame.contentWindow?.print();
      }
      finally {
        setTimeout(() => frame.remove(), 1000);
      }
    }, 100);
  }

  //#endregion

  requireAdminApproval(action: () => void): void {
    if (this.currentUser?.accesscontrol?.name === 'Venue Administrator') {
      action();
      return;
    }
    this.adminOverridePending = action;
    this.adminOverrideSelectedId = '';
    this.adminOverridePin = '';
    this.http.get<venueuser_returndata>(bmxurl + 'UserList/' + this.VenueID + '/false').subscribe({
      next: (response) => {
        this.adminOverrideUsers = (response.data ?? []).filter(u => u.accesscontrol?.name === 'Venue Administrator');
        if (this.adminOverrideUsers.length === 0) {
          this.messageService.add({ severity: 'error', summary: 'No Administrators', detail: 'No Venue Administrator accounts found.' });
          this.adminOverridePending = null;
          return;
        }
        this.showAdminOverride = true;
      },
      error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load administrator list.' })
    });
  }

  submitAdminOverride(): void {
    if (!this.adminOverrideSelectedId || !this.adminOverridePin) {
      this.messageService.add({ severity: 'warn', summary: 'Required', detail: 'Please select an administrator and enter their PIN.' });
      return;
    }
    const payload = { venueid: this.VenueID, userid: this.adminOverrideSelectedId, pin: this.adminOverridePin };
    this.http.post<any>(bmxurl + 'pinauth', payload).subscribe({
      next: (response) => {
        if (response.succeeded) {
          const pending = this.adminOverridePending;
          this.cancelAdminOverride();
          if (pending) pending();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Authorisation Failed', detail: response.messages?.[0] ?? 'Incorrect PIN.' });
        }
      },
      error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not verify credentials.' })
    });
  }

  cancelAdminOverride(): void {
    this.showAdminOverride = false;
    this.adminOverrideSelectedId = '';
    this.adminOverridePin = '';
    this.adminOverridePending = null;
  }
}